// extracted by mini-css-extract-plugin
module.exports = {"trafficLightContainer":"TrafficLight_trafficLightContainer__1pCsm"};